import React, { useEffect, useState } from 'react';
import { Box, Alert } from '@mui/material';
import TransactionsManagement from './Transactions/ManageTransactions.js';
import WithdrawalRequests from './Transactions/WithdrawRequests.js';
import DashboardStats from './Transactions/DashboardStats.js';
import DashboardLayout from './DashboardLayout.js';
import baseURL from '../config.js';
import PageLoader from '../../../Reusable/PageLoader.js';

const Transactions = () => {
  const [stats, setStats] = useState(null);
  const [transactions, setTransactions] = useState([]);
  const [withdrawals, setWithdrawals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        // await new Promise(resolve => setTimeout(resolve, 4000));

        const [statsResponse, transactionsResponse, withdrawalsResponse] = await Promise.all([
          fetch(`${baseURL}/admin/dashboard/stats`, { credentials: 'include' }),
          fetch(`${baseURL}/admin/admin-transactions`, { credentials: 'include' }),
          fetch(`${baseURL}/admin/withdraw-requests`, { credentials: 'include' }),
        ]);

        if (!statsResponse.ok) throw new Error("Failed to fetch dashboard stats.");
        if (!transactionsResponse.ok) throw new Error("Failed to fetch transactions.");
        if (!withdrawalsResponse.ok) throw new Error("Failed to fetch withdrawal requests.");

        const statsData = await statsResponse.json();
        const transactionsData = await transactionsResponse.json();
        const withdrawalsData = await withdrawalsResponse.json();

        setStats(statsData);
        setTransactions(transactionsData);
        setWithdrawals(withdrawalsData);

      } catch (err) {
        console.error("Error fetching data:", err);
        setError(err.message || "An unexpected error occurred. Please try again.");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading) {
    return (
      <DashboardLayout>
        {/* Use the new PageLoader component for the loading state */}
        <PageLoader message="Loading transaction data..." />
      </DashboardLayout>
    );
  }

  if (error) {
    return (
      <DashboardLayout>
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
          <Alert severity="error">{error}</Alert>
        </Box>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <DashboardStats stats={stats} />
      <TransactionsManagement transactions={transactions} />
      <WithdrawalRequests withdrawals={withdrawals} />
    </DashboardLayout>
  );
};

export default Transactions;